import React, {useEffect, useState} from "react";
import reviewService from "../services/ReviewService";
import axios from "axios";
import {Link} from "react-router-dom";

const EXTURL = 'https://api.documenu.com/v2/restaurant/';


// Adds a review to a restaurant by taking restaurant id.
const AddReview = (hotelId) => {
    let [newReview, setnewReview] = useState([]);
    const[user, setUser] = useState("")
    useEffect( () =>{
        axios.get('  https://food-mafia-server.herokuapp.com/api/checkLogin').
        then(response => {

            if(response.data.name){
                //console.log("here!!")
                setUser(response.data)
            }
        });
    }, []);


    let newURL = EXTURL + hotelId.hotelId + "?key=dae1adbe76c43e4a90fcc9f67fd412ea";

    const[results, setResults] = useState({data:[]});

    const findResults = () =>
        fetch(newURL)
            .then(res => res.json())
            .then(results => setResults(results));

    useEffect(findResults,[]);
    const reviewClickHandler = () => {
        reviewService.createReview({
            "userId": user.userId,
            "restaurantId" : parseInt(hotelId.hotelId),
            "name" : user.name,
            "desc" : newReview,
            "restaurantName": results.result.restaurant_name

        })
            .then(actualreview =>
                setnewReview([
                    actualreview, ...newReview
                ]));
    }
    return (
        <div>
            <div className="row m-2">
                <div className="wd-col-twentyPercent col-sm-2 col-md-2 col-lg-2 col-xl-1 col-xxl-1">
                    <img src="https://i.picsum.photos/id/365/5616/3744.jpg?hmac=m9Chefr19BelgN9G4ErJVFBbdvNmA_xlbd0CjATLwhM"
                         className="img-fluid wd-main-image wd-img" alt = "profilePic"/>
                </div>
                <div className="wd-col-eightyPercent col-sm-10 col-md-10 col-lg-6 col-xl-6 col-xxl-6 ">
                    <div className="row">
                        <textarea className="form-control wd-textarea" id="exampleTextarea" rows="3"
                                  onChange={(event) =>
                                      setnewReview(event.target.value)}></textarea>
                    </div>
                    {/*<button type="button" className="btn btn-danger rounded-3"><i className="far fa-star"/> Add Review*/}
                    {/*</button>*/}
                    <div className="row">
                        <div className=" m-0 p-0">


                        {
                            user && <button className="btn btn-danger rounded-3 mt-3 mb-3" onClick={reviewClickHandler} style={{float:"right"}}>
                                <i className="far fa-star"/>   Add Review
                            </button>
                        }
                        {
                            !user &&
                                <Link to="/login">
                            <button className="btn btn-primary rounded-pill mt-3 mb-3" style={{float:"right"}}>
                                Add Review
                            </button>
                                </Link>
                        }
                        </div>

                    </div>



                </div>
            </div>
        </div>
    );
}

export default AddReview;